export default (that) => [
  {
    text: that.$l('INDEX.btn_tips_view') || '详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_text_message') || '邮件提醒',
    icon: 'el-icon-message',
    menuType: 'message',
    divided: true,
    allow: 'M',
    disabled: ({ receiveStatus }) => receiveStatus !== 'N',
  },
  {
    text: that.$l('btn_text_check') || '收到发票',
    icon: 'el-icon-check',
    menuType: 'check',
    divided: true,
    allow: 'C',
    disabled: ({ receiveStatus }) => receiveStatus !== 'N',
  },
]
